import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import bannerCloud from "../../img/home/banner-cloud.webp";
import avatar1 from "../../img/home/stats-avatar-1.webp";
import avatar2 from "../../img/home/stats-avatar-2.webp";
import avatar3 from "../../img/home/stats-avatar-3.webp";

const CARD_STYLE = {
  backgroundImage: "linear-gradient(90deg, rgba(10,22,40,0.9) 0%, rgba(26,46,74,0.9) 100%)",
  backdropFilter: "blur(16px)",
};

function StatRow({ value, label, className = "flex-row items-baseline" }) {
  return (
    <div className={`flex gap-[12px] whitespace-nowrap ${className}`}>
      <span className="font-64-42">{value}</span>
      <span className="font-['Inter'] font-medium text-[14px] sm:text-[18px] text-[rgba(255,255,255,0.75)] capitalize">
        {label}
      </span>
    </div>
  );
}

function StatsBlock() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer">
        <Fade triggerOnce direction="up" duration={700}>
        <div className="flex flex-col lg:flex-row gap-[18px] lg:gap-[31px]">
          {/* Левая большая карточка */}
          <div
            className="relative overflow-hidden rounded-[20px] lg:rounded-[28px] p-[32px] lg:p-[40px] flex flex-col gap-[24px] lg:gap-[20px] lg:w-[48.5%] shrink-0 hover:-translate-y-[4px] transition-transform duration-300"
            style={CARD_STYLE}
          >
            <img
              src={bannerCloud}
              alt=""
              aria-hidden
              className="absolute left-[-20%] top-[-45%] w-[120%] opacity-25 pointer-events-none select-none"
            />
            <div className="relative flex flex-col gap-[12px]">
              <h2 className="font-56-28">{t("stats.title")}</h2>
              <p className="font-['Inter'] font-normal text-[14px] sm:text-[18px] text-[rgba(255,255,255,0.65)] leading-[1.5]">
                {t("stats.subtitle")}
              </p>
            </div>
            <div className="relative">
              <StatRow value={t("stats.clients")} label={t("stats.clientsLabel")} />
            </div>
          </div>

          {/* Правые карточки */}
          <div className="flex flex-row lg:flex-col gap-[8px] sm:gap-[18px] lg:gap-[32px] flex-1">
            {/* 120+ countries */}
            <div
              className="relative overflow-hidden rounded-[20px] lg:rounded-[28px] p-[24px] sm:p-[32px] lg:px-[40px] lg:py-[44px] flex-1 flex items-center justify-between lg:h-[166px]"
              style={CARD_STYLE}
            >
              <StatRow
                value={t("stats.countries")}
                label={t("stats.countriesLabel")}
                className="flex-col items-start gap-[6px] lg:flex-row lg:items-baseline lg:gap-[12px]"
              />
              <div className="hidden lg:flex gap-[9px]">
                {[avatar1, avatar2, avatar3].map((avatar, i) => (
                  <img
                    key={i}
                    src={avatar}
                    alt=""
                    aria-hidden
                    className="w-[62px] h-[62px] rounded-full object-cover select-none"
                  />
                ))}
              </div>
            </div>

            {/* 0.0 spreads */}
            <div
              className="relative overflow-hidden rounded-[20px] lg:rounded-[28px] p-[24px] sm:p-[32px] lg:px-[40px] lg:py-[44px] flex-1 flex items-center lg:h-[166px]"
              style={CARD_STYLE}
            >
              <img
                src={bannerCloud}
                alt=""
                aria-hidden
                className="absolute right-[-20%] top-[-35%] w-[100%] opacity-25 pointer-events-none select-none"
              />
              <div className="relative">
                <StatRow
                  value={t("stats.spreads")}
                  label={t("stats.spreadsLabel")}
                  className="flex-col items-start gap-[6px] lg:flex-row lg:items-baseline lg:gap-[12px]"
                />
              </div>
            </div>
          </div>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default StatsBlock;
